var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.1654 11.6666V24.9999H10.582C7.96536 24.9999 5.83203 27.1333 5.83203 29.7499V11.6666C5.83203 4.99992 7.4987 3.33325 14.1654 3.33325H25.832C32.4987 3.33325 34.1654 4.99992 34.1654 11.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1654 25V30.8333C34.1654 34.05 31.5487 36.6667 28.332 36.6667H11.6654C8.4487 36.6667 5.83203 34.05 5.83203 30.8333V29.75C5.83203 27.1333 7.96536 25 10.582 25H34.1654Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6654 12.9167H13.332C12.6487 12.9167 12.082 12.3501 12.082 11.6667C12.082 10.9834 12.6487 10.4167 13.332 10.4167H26.6654C27.3487 10.4167 27.9154 10.9834 27.9154 11.6667C27.9154 12.3501 27.3487 12.9167 26.6654 12.9167Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6654 18.75H13.332C12.6487 18.75 12.082 18.1833 12.082 17.5C12.082 16.8167 12.6487 16.25 13.332 16.25H21.6654C22.3487 16.25 22.9154 16.8167 22.9154 17.5C22.9154 18.1833 22.3487 18.75 21.6654 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon25);
export default __webpack_public_path__ + "static/media/icon-25.7025cc5018567ca4378457eff7693aed.svg";
export { ForwardRef as ReactComponent };